import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { effect, inject } from '@angular/core';
import { UserService } from '../services/user.service';

export const unauthorizedGuard: CanActivateFn = (route, state) => {

  const router: Router = inject(Router);
  const authService: AuthService = inject(AuthService);
  const userService: UserService = inject(UserService);
  const allowAccess = authService.isAuthenticated() && userService.isAuthorized();

     if (allowAccess) {
        // if the user is authenticated and authorized, redirect them to the root page
        // this may happen when the user has access and tries to reload the unauthenticated page
        router.navigate(['/']);
      }
      if (!authService.isAuthenticated()) {
        // if the user is not authenticated, redirect to unauthenticated page
        // this may happen when the user lost the authentication and tries to reload the unauthorized page
        router.navigate(['/unauthenticated']);
      }
  return true;
};
